// polyfill
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
// redux
import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import rootReducer from "./modules";

import "./styles/reset.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import ReactGA from "react-ga";
import { createBrowserHistory } from "history";

ReactGA.initialize("UA-60784376-2");

const history = createBrowserHistory();

// Initialize google analytics page view tracking
history.listen(location => {
  ReactGA.set({ page: location.pathname }); // Update the user's current page
  ReactGA.pageview(location.pathname); // Record a pageview for the given page
});

const devTools =
  process.env.NODE_ENV === "production"
    ? applyMiddleware(thunk)
    : composeWithDevTools(applyMiddleware(thunk));

const store = createStore(rootReducer, devTools);

const agent = navigator.userAgent.toLowerCase();
if (
  (navigator.appName === "Netscape" && agent.indexOf("trident") !== -1) ||
  agent.indexOf("msie") !== -1 ||
  agent.indexOf("edge") !== -1
) {
  // ie, edge일 경우 alert 노출
  alert(
    "이 페이지는 크롬 브라우저에 최적화되어있으므로 크롬 브라우저 사용을 권장합니다."
  );
}

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <CookiesProvider>
        <App />
      </CookiesProvider>
    </Router>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
